/* tslint:disable */
/* eslint-disable */
/**
 * CipherMail back-end API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @enum {string}
 */

export const PGPSearchField = {
    Email: 'EMAIL',
    UserId: 'USER_ID',
    KeyId: 'KEY_ID',
    Fingerprint: 'FINGERPRINT'
} as const;

export type PGPSearchField = typeof PGPSearchField[keyof typeof PGPSearchField];



